module.exports = __webpack_public_path__ + "static/media/vis12.4a7bb737.jpeg";